<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-select
                ttRememberId="w_shopfloor.businessco_no"
                ttLabel="businessco"
                [(ttModel)]="setting.businessco_no"
                (ttModelChange)="onChanged($event, 'businessco_no')"
                [ttData]="selectListCompanies"
                ttDataId="businessco_no"
                ttDataName="company_name"
            ></tt-select>
            <tt-select
                ttRememberId="w_shopfloor.factory_id"
                ttLabel="factory_name"
                [(ttModel)]="setting.factory_id"
                (ttModelChange)="onChanged($event, 'factory_id')"
                [ttData]="selectListFactories"
                ttDataId="factory_id"
                ttDataName="factory_name"
            ></tt-select>
            <tt-select
                ttRememberId="w_shopfloor.operation_id"
                ttLabel="operation"
                [(ttModel)]="setting.operation_id"
                (ttModelChange)="onChanged($event, 'operation_id')"
                [ttData]="selectListOperations"
                ttDataId="item_id"
                ttDataName="item_name"
                [ttClearValue]="''"
                ttShowClearButton
            ></tt-select>
            <tt-select
                ttRememberId="w_shopfloor.equipment_id"
                ttLabel="equipment"
                [(ttModel)]="setting.equipment_id"
                (ttModelChange)="onChanged($event, 'equipment_id')"
                [ttData]="selectListEquipments"
                ttDataId="item_id"
                ttDataName="item_name"
                [ttClearValue]="''"
                ttShowClearButton
            ></tt-select>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-checkbox
                ttRememberId="w_shopfloor.group_by_component"
                ttLabel="group_by_component"
                [(ttModel)]="setting.group_by_component"
                (ttModelChange)="onChanged($event, 'group_by_component')"
            ></tt-checkbox>
            <tt-button-settings *ngIf="setting.show_setting === '1'"></tt-button-settings>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
